import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
///import { spinner, spinnerClose } from '../helpers/spinners';
import { startSpinner,finishSpinner } from "./ui/spinner";

export const aportesTraerStart = () => ({ type: types.aportesTraerStart });
export const aportesLimpiar = () => ({ type: types.aportesLimpiar });
export const aportesTraerError = (error) => ({ type: types.aportesTraerError,payload: error});
export const aportesTraerSuccess = (payload) => {
    return {
      type: types.aportesTraerSuccess,
      payload: payload
    }
  }
  
export const fetchAportes = (CUIL) => {
    return async (dispatch) => {
     dispatch(startSpinner());
        dispatch(aportesTraerStart());
      const response = await fetchConToken(`Aportes/${CUIL}`);
      if (!response.ok) {
          dispatch(aportesTraerError(response.statusText));
        throw Error(response.statusText);
      }
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.indexOf("application/json") !== -1) {
        const lista = await response.json();
        // if (lista.length>0) {
          dispatch(aportesTraerSuccess(lista));
        // }
      }
     dispatch(finishSpinner());
    };
  };
